import { useReducer } from "react";
import { scrollTop } from "utils";
import { DEFAULT_TOTAL_RECORDS } from "utils/constants";

export const UPADTE_CURRENT_PAGE = "UPADTE_CURRENT_PAGE";
export const UPDATE_ITEM_PER_PAGE = "UPDATE_ITEM_PER_PAGE";
export const UPDATE_NEW_PAGINATION = "UPDATE_NEW_PAGINATION";
export const UPDATE_DISABLE_PREV = "UPDATE_DISABLE_PREV";
export const UPDATE_DISABLE_NEXT = "UPDATE_DISABLE_NEXT";
export const UPDATE_TOTOAL_RECORDS = "UPDATE_TOTOAL_RECORDS";

const reducer = (state, action) => {
  switch (action.type) {
    case UPADTE_CURRENT_PAGE:
      scrollTop();
      return {
        ...state,
        currentPage: action.payload,
        disablePrev: action.payload === 1,
        disableNext: action.payload === state.totalPages,
        disableFirst: action.payload === 1,
        disableLast: action.payload === state.totalPages,
      };
    case UPDATE_ITEM_PER_PAGE:
      const totalPagesAfterUpdate = Math.ceil(
        state.totalRecords / action.payload
      );
      return {
        ...state,
        itemPerPage: action.payload,
        totalPages: totalPagesAfterUpdate,
        currentPage: 1,
        disablePrev: true,
        disableFirst: true,
        disableNext: totalPagesAfterUpdate <= 1,
        disableLast: totalPagesAfterUpdate <= 1,
      };
    case UPDATE_DISABLE_PREV:
      return {
        ...state,
        disablePrev: action.payload,
      };
    case UPDATE_DISABLE_NEXT:
      return {
        ...state,
        disableNext: action.payload,
      };
    case UPDATE_TOTOAL_RECORDS:
      const totalPages = Math.ceil(action.payload / state.itemPerPage);
      return {
        ...state,
        totalRecords: action.payload,
        totalPages,
        disableNext: state.currentPage === totalPages,
        disableLast: state.currentPage === totalPages,
      };
    default:
      return state;
  }
};

const usePagination = (initialItemsPerPage = DEFAULT_TOTAL_RECORDS) => {
  const initialState = {
    currentPage: 1,
    itemPerPage: initialItemsPerPage,
    newPagination: 2,
    disablePrev: true,
    disableNext: false,
    disableFirst: true,
    disableLast: false,
    totalPages: 0,
    totalRecords: 0,
  };

  const [
    {
      currentPage,
      itemPerPage,
      newPagination,
      disablePrev,
      disableNext,
      disableFirst,
      disableLast,
      totalPages,
      totalRecords,
    },
    dispatch,
  ] = useReducer(reducer, initialState);

  const updateCurrentPage = (page) => {
    dispatch({ type: UPADTE_CURRENT_PAGE, payload: page });
  };

  const updateItemPerPage = (itemsPerPage) => {
    dispatch({ type: UPDATE_ITEM_PER_PAGE, payload: itemsPerPage });
  };

  const updateDisablePrev = (payload) => {
    dispatch({ type: UPDATE_DISABLE_PREV, payload });
  };

  const updateDisableNext = (payload) => {
    dispatch({ type: UPDATE_DISABLE_NEXT, payload });
  };

  const updateTotalRecords = (payload) => {
    dispatch({ type: UPDATE_TOTOAL_RECORDS, payload });
  };

  return {
    currentPage,
    itemPerPage,
    newPagination,
    disablePrev,
    disableNext,
    disableFirst,
    disableLast,
    totalPages,
    totalRecords,
    updateCurrentPage,
    updateItemPerPage,
    updateDisablePrev,
    updateDisableNext,
    updateTotalRecords,
  };
};

export default usePagination;
